const map = {
	"./GitHub-Copilot.jpg": 86117,
	"./HEX_corto.avif": 51198,
	"./article-25-thumbnail.webp": 12300,
	"./article-25.webp": 55569,
	"./article-26-thumbnail.webp": 49053,
	"./article-26.webp": 96308,
	"./article-27-thumbnail.webp": 40714,
	"./article-27.webp": 19319,
	"./article-28-thumbnail.webp": 58691,
	"./article-28.webp": 94674,
	"./article-29-thumbnail.webp": 73736,
	"./article-29.webp": 46013,
	"./article-30-thumbnail.webp": 53570,
	"./article-30.webp": 27055,
	"./article-header.webp": 31077,
	"./articles-header.jpg": 95450,
	"./articles-header.webp": 18436,
	"./average-conversion-ratio.avif": 76219,
	"./average-grades-increase.jpg": 98872,
	"./aws.avif": 96928,
	"./clinical-data.avif": 6225,
	"./comparative.avif": 28228,
	"./cough.avif": 82631,
	"./coversion-rate.avif": 88616,
	"./open-thread.avif": 76914,
	"./productivity-increases-ai.jpg": 73124,
	"./time-taken-decreases.jpg": 80418,
	"./tiny-chef.avif": 26696,
	"./transcript.avif": 83941
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44111;